// packages/web-ui/src/AppShell/drawer-tabs/DetailTab.tsx
//
// W2-S9 — Detail tab body. Polymorphic inspector keyed on
// `navigation.activeDestination` (UX §7.5).
//
//   destination === 'kb'                 → <KbEntityInspector> (W4-S6 wires)
//   destination === 'files'              → outline-tree placeholder (W3-S2)
//   destination === 'views'              → node-properties placeholder (W4-S1)
//   destination === 'chat' / 'diff' /
//                   'settings'           → empty-state ("Select an item…")
//
// THIS file lands the polymorphic switch + the three placeholder branches.
// The live KB-entity inspector wiring is OUT OF SCOPE — it depends on
// the W4-S6 `kb` slice that has not landed yet.

import type { JSX } from 'react';
import type { ActiveDestination } from '../../state/navigation.js';

export interface DetailTabProps {
  /** Active destination — drives which polymorphic content renders. */
  destination: ActiveDestination;
}

const COPY_FILES = 'Outline tree — populated in W3-S2 (Files CM6).';
const COPY_VIEWS = 'Node properties — populated in W4-S1 (View Renderer).';
const COPY_KB = 'KB entity inspector — populated in W4-S6 (KB Browser detail card).';
const COPY_EMPTY = 'Select an item in the active tab to see details here.';

export function DetailTab({ destination }: DetailTabProps): JSX.Element {
  let body: JSX.Element;
  switch (destination) {
    case 'kb':
      body = (
        <div className="px-4 py-8 text-center text-xs italic text-taupe-700">{COPY_KB}</div>
      );
      break;
    case 'files':
      body = (
        <div className="px-4 py-8 text-center text-xs italic text-taupe-700">{COPY_FILES}</div>
      );
      break;
    case 'views':
      body = (
        <div className="px-4 py-8 text-center text-xs italic text-taupe-700">{COPY_VIEWS}</div>
      );
      break;
    case 'chat':
    case 'diff':
    case 'settings':
    default:
      body = (
        <div className="px-4 py-8 text-center text-xs italic text-taupe-700">{COPY_EMPTY}</div>
      );
      break;
  }

  return (
    <div
      id="drawer-panel-detail"
      role="tabpanel"
      aria-labelledby="drawer-tab-detail"
      data-testid="drawer-panel-detail"
      data-destination={destination}
      className="flex flex-1 flex-col overflow-hidden"
    >
      {body}
    </div>
  );
}
